module.exports = __webpack_public_path__ + "img/verbose-2.f02ceb49.png";